import React from 'react';
import CourseCard from './CourseCard';

const CourseGrid = ({ courses, onCourseSelect }) => {
  return (
    <div className="py-8">
      {/* Header */}
      <div className="text-center mb-8 sm:mb-12 md:mb-16 max-w-4xl mx-auto px-4">
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
          Master New Skills in 3 Months
        </h1>
        
        <p className="text-lg sm:text-xl text-gray-600 mb-4 sm:mb-6 leading-relaxed">
          Comprehensive foundational courses designed for curious minds
        </p>
        
        <p className="text-base sm:text-lg text-gray-500 leading-relaxed max-w-3xl mx-auto">
          Each intensive 12-week program combines theory with hands-on practice, 
          giving you the tools to excel in today's most in-demand fields.
        </p>
      </div>
      
      {/* Course Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {courses.map((course, index) => (
          <div 
            key={course.id} 
            className="animate-slide-up"
            style={{ '--stagger': index }}
          >
            <CourseCard 
              course={course} 
              onSelect={onCourseSelect}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseGrid;